import { bootstrap, createWorkloadClient } from '@ms-fabric/workload-client';

import { BootstrapConfig, FabricinitializeWorker } from './common-types';

type BootstrapConfigCustom = {
	initializeWorker: FabricinitializeWorker;
} & Omit<BootstrapConfig, 'initializeWorker'>;

export const MSFabricbootstrap = async ({ initializeUI, initializeWorker }: BootstrapConfigCustom) => {
	const redirectUriPath = '/close';
	const url = new URL(window.location.href);
	if (url.pathname?.startsWith(redirectUriPath)) {
		window.close();
	}

	bootstrap({
		initializeUI,
		initializeWorker: (params) => {
			const extensionClient = createWorkloadClient();
			return initializeWorker(extensionClient, params);
		},
	});
};
